/** A project's test login as the Editor shows it (release Plan 4). */
export interface TestLoginView { roleId: string; email: string; password: string; rotatedAt: string; daysUntilRotation: number }

export function rotatesInLabel(days: number): string {
  if (days <= 0) return 'Rotates today';
  return `Rotates in ${days} ${days === 1 ? 'day' : 'days'}`;
}
